export const APP_PRODUCTION_STATUS_TEXT = {
  REQUESTED: '제작 요청 접수 대기',
  ACCEPTED: '제작 요청 접수 완료',
  IN_PROGRESS: '제작 진행 중',
  COMPLETED: '제작 완료',
  CANCELED: '제작 취소',
}

export const DEFAULT_APP_CALL_NAME = '하늘이'

export const getAppProductionStatusText = (status) => {
  if (!status) return ''
  return APP_PRODUCTION_STATUS_TEXT[status] || status
}

export const isCompletedAppProduction = (app) => {
  return app?.productionStatus === 'COMPLETED' || Boolean(app?.resultUrl)
}

export const hasPaidAppProduction = (app) => {
  return Boolean(app?.resultUrl || (app?.productionStatus && app.productionStatus !== 'CANCELED'))
}

export const getAppTitleCallName = (app, heroCallName) => {
  return isCompletedAppProduction(app)
    ? heroCallName || DEFAULT_APP_CALL_NAME
    : DEFAULT_APP_CALL_NAME
}

export const replaceAppTitleCallName = (text, app, heroCallName) => {
  return (text || '').replace(/\{callName\}/g, getAppTitleCallName(app, heroCallName))
}
